import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import TanstackQueryProvider from 'providers/TanstackQuery';
import AppStateProvider from 'providers/AppState';

import AppRouter from './navigation/AppRouter';
import { NOTISTACK_OPTIONS } from './utils/constants';

const helmetContext = {};

export default function AppWithProviders() {
  useEffect(() => {
    document.title = process.env.REACT_APP_NAME || 'Smoove Exchange';
  }, []);

  return (
    <SnackbarProvider {...NOTISTACK_OPTIONS}>
      <TanstackQueryProvider>
        <AppStateProvider>
          <HelmetProvider context={helmetContext}>
            <AppRouter />
          </HelmetProvider>
        </AppStateProvider>
      </TanstackQueryProvider>
    </SnackbarProvider>
  );
}
